import { HostListener, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestsService } from '../../Services/Tests/TestsService';
import { LoginService } from '../../Services/GlobalServices/login.service';
import { UserService } from '../../Services/User/UserService';
import { AlertService } from '../../Services/Alert/Alert.service';
import { isNullOrUndefined } from 'util';
import { BuyerTest, ExamCommentViewModel, OptionsViewModel, QuestionViewModel, Test_Questions, Test_QuestionsOptions } from '../../../Models/Tests/tests.models';

@Component({
  selector: 'app-examsummary',
  templateUrl: './examsummary.component.html',
  styleUrls: ['./examsummary.component.scss']
})

export class ExamsummaryComponent implements OnInit {

  constructor(private alertService: AlertService, private route: ActivatedRoute, private router: Router, private testService: TestsService, private loginService: LoginService, private userService: UserService) {

  }

  resultLoaded: boolean = false;

  pkBuyerTestId: string;
  currentUserId: string;
  buyerTest: BuyerTest;
  tvm: any;
  alphabets: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  percentageScored: number;
  isPassed: boolean;
  marksScoredforEachQuestion: number;
  examComment: ExamCommentViewModel;
  userId: string;
  newTVM: boolean = false;
  testQuestions: Test_Questions[] = [];
  testQuestionsOptions: Test_QuestionsOptions[] = [];
  active: string = "";
  currentQuestion: Test_Questions;
  currentIndex: number;
  currentQuestionRightOrWrong: boolean = false;
  comment: string;

  ngOnInit() {
    window.scrollTo(0, 0);
    this.examComment = new ExamCommentViewModel();
    this.userId = this.loginService.getCurrentUserId();
    this.pkBuyerTestId = this.route.snapshot.paramMap.get("id");
    this.currentUserId = this.loginService.getCurrentUserId();
    let waitTime = 1000;
    new Promise<void>(resolve => setTimeout(() => resolve(), waitTime)).then(() =>
      this.getBuyerTest()
    );
  }

  getBuyerTest() {
    this.testService.GetBuyerTestById(this.pkBuyerTestId).subscribe((result) => {
      this.buyerTest = result;
      let pseudoObject = <any>this.buyerTest.JsonAsString;
      this.tvm = JSON.parse(pseudoObject);
      this.GradeCalculation();
      if (isNullOrUndefined(this.tvm.Questions[0].Description)) {
        this.newTVM = true;
        this.testService.getAllExamQuestionsbyId(this.tvm.FKTestId).subscribe((res) => {
          this.testQuestions = res;
          this.resultLoaded = true;
        })
      }
      else {
        this.resultLoaded = true;
      }
    })
  }

  CheckWrongAnswers(option: OptionsViewModel, question: QuestionViewModel) {
    if (!option.IsCorrect) {
      for (let opt of question.SelectedOptions) {
        if (opt.PKOptionId == option.PKOptionId && opt.IsCorrect != false) {
          return true;
        }
      }
    }
    else {
      return false;
    }
  }

  CheckboxOrRadioButton(question: QuestionViewModel): boolean {
    let count = 0;
    for (let option of question.Options) {
      if (option.IsCorrect) {
        count++;
      }
    }

    if (count > 1) {
      return true;
    }
    else {
      return false;
    }
  }

  CheckboxOrRadioButtonNew(testOptions: Test_QuestionsOptions[]): boolean {
    let count = 0;
    for (let option of testOptions) {
      if (option.IsCorrect) {
        count++;
      }
    }

    if (count > 1) {
      return true;
    }
    else {
      return false;
    }
  }

  checkOptions(option: OptionsViewModel, question: QuestionViewModel) {
    if (question.SelectedOptions != null) {
      for (let i of question.SelectedOptions) {
        if (i.PKOptionId == option.PKOptionId) {
          this.marksScoredforEachQuestion = 0;
          return true;
        }
      }
    }
    else {
      this.marksScoredforEachQuestion = question.MarksAllocated;
      return false;
    }
  }

  GradeCalculation() {
    let totalMarks = 0;
    if (!isNullOrUndefined(this.tvm.Questions[0].Description)) {
      for (let i of this.tvm.Questions) {
        totalMarks += i.MarksAllocated;
      }
    }
    else {
      totalMarks = this.tvm.TotalMarksAllocated;
    }
    this.percentageScored = Math.trunc((this.buyerTest.MarksScored / totalMarks) * 100)
    if (this.percentageScored >= this.tvm.PassPercentage) {
      this.isPassed = true;
    }
    else {
      this.isPassed = false;
    }
  }

  postcomment(comment, questionumber: number, questionDes: string, examTitle: any) {
    let qnumber: number = +questionumber + 1;
    this.examComment.UserEmail = this.loginService.getEmail();
    this.examComment.UserName = this.loginService.getUserName();
    this.examComment.ExamLink = window.location.href;
    this.examComment.Comment = comment;
    this.examComment.QuestionNumber = qnumber + '';
    this.examComment.QuestionDescription = questionDes;
    this.examComment.TestName = examTitle;
    if (this.examComment.Comment.length > 10) {
      this.userService.ExamComment(this.examComment).subscribe((res) => {
        this.comment = '';
        this.alertService.success("Your Comment on the question has been Successful, Thank you.");
      });
    }
    else {
      this.alertService.error("Comment cannot be less than 10 characters")
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    window.history.go(-1);
  }

  toggleAccordian(event, question?: Test_Questions) {
    this.comment = '';
    if (this.newTVM) {
      this.currentIndex = event.panelId;
      this.currentQuestion = this.testQuestions[this.currentIndex];
      var selectedOptionsId: string;
      for (let i of this.tvm.Questions) {
        if (this.currentQuestion.PKTestQuestionId == i.QuestionId) {
          selectedOptionsId = i.SelectedOptionId;
        }
      }

      if (!isNullOrUndefined(selectedOptionsId)) {
        var selectedOptionArray = selectedOptionsId.split(',');
        selectedOptionArray.splice(-1, 1);
      }
      else {
        selectedOptionArray = [];
      }

      this.testService.GetAllOptionsWithQuestionId(this.currentQuestion.PKTestQuestionId).subscribe((res) => {
        this.testQuestionsOptions = res;
        var correctOptionsNumber: number = 0;
        var selectedCorrectOptionsNumber: number = 0;
        for (let j of this.testQuestionsOptions) {
          if (j.IsCorrect) {
            correctOptionsNumber++;
          }
          if (selectedOptionArray.length > 0) {
            for (let i of selectedOptionArray) {
              if (i == j.PKOptionId) {
                j.isSelectedOption = true;
                if (j.IsCorrect) {
                  selectedCorrectOptionsNumber++;
                }
              }
            }
          }
        }
        if (correctOptionsNumber == selectedCorrectOptionsNumber && selectedOptionArray.length > 0) {
          this.currentQuestionRightOrWrong = true;
        }
        else {
          this.currentQuestionRightOrWrong = false;
        }

        this.active = this.active == event.panelId ? "" : event.panelId;
      })
    }
    else {
      this.active = this.active == event.panelId ? "" : event.panelId;
    }
  }
}
